import InitAttachField from './initAttachField';
import { InitCodeInputs } from './codeInput';
import InitDateField from './initDateField';
import InitDemo from './initDemo';
import InitInquiry from './initInquiry';
import InitModal from './initModal';
import InitNavigation from './initNavigation';
import InitNotice from './initNotice';
import InitOrderList from './initOrderList';
import InitPartnerApp from './initPartnerApp';
import InitPartnerAppRecords from './initPartnerAppRecords';
import InitPartnerGuide from './initPartnerGuide';
import InitPartnerImport from './initPartnerImport';
import InitPartnerNav from './initPartnerNav';
import InitPartnerNews from './initPartnerNews';
import InitPartnerProfile from './initPartnerProfile';
import InitPartnerQr from './initPartnerQr';
import InitPartnerShops from './initPartnerShops';
import InitPartnerStaff from './initPartnerStaff';
import InitPartnerSupport from './initPartnerSupport';
import InitPromoSlider from './initPromoSlider';
import InitRichText from './initRichText';
import InitSearchField from './initSearchField';
import InitShopRegister from './initShopRegister';
import InitShopSetup from './initShopSetup';
import InitSpyNav from './initSpyNav';
import InitStepper from './initStepper';
import InitShopSetupEditor from './initShopSetupEditor';
import InitStickyBar from './initStickyBar';
import InitTodo from './initTodo';
import InitUploader from './initUploader';

InitAttachField();
InitCodeInputs();
InitDateField();
InitDemo();
InitInquiry();
InitModal();
InitNavigation();
InitNotice();
InitOrderList();
InitPartnerApp();
InitPartnerAppRecords();
InitPartnerGuide();
InitPartnerImport();
InitPartnerNav();
InitPartnerNews();
InitPartnerProfile();
InitPartnerQr();
InitPartnerShops();
InitPartnerStaff();
InitPartnerSupport();
InitPromoSlider();
InitRichText();
InitSearchField();
InitShopRegister();
InitShopSetup();
InitSpyNav();
InitStepper();
InitShopSetupEditor();
InitStickyBar();
InitTodo();
InitUploader();
